module.exports = __webpack_public_path__ + "img/Rectangle 225@2x.b98b4b84.png";